import script from "./MDataTableSelectionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MDataTableSelectionBar.vue?vue&type=script&setup=true&lang=js"

import "./MDataTableSelectionBar.vue?vue&type=style&index=0&id=3910e83f&lang=scss"

const __exports__ = script;

export default __exports__